<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search" class="transaction-search" :search-condition="searchCondition"
        :search-buttons="searchButtonList" :fuzzySearchPlaceholder="fuzzySearchPlaceholder" fuzzy-search-key="keywords"
        :showMerchantSearch="true" router-name="/transaction/dividend">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition" :first-parameters="getInitParams()" ref="table"
        :service-function="queryList" :is-first-automatic-visit="false" :showMerchantNo="true"
        router-name="/transaction/dividend">
      </custom-table>
    </div>
  </div>
</template>
<script>
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getWeekParams, initWeek } from '@/utils/tools/time';
import DividendService from '@/views/transaction/api/dividend.service';

export default {
  components: {
    SearchComponent,
    CustomTable,
  },
  data() {
    return {
      // eslint-disable-next-line max-len
      fuzzySearchPlaceholder: `${this.$t('message.tableCommon.merchantOrderNumber')};${this.$t('message.tableCommon.txnSerialNumber')};${this.$t('message.tableCommon.originalTxnSerialNumber')};${this.$t('message.transaction.dividendDetailsNo')};${this.$t('message.transaction.dividendTxnSerialNo')}`,
      searchCondition: [
        {
          key: 'status',
          name: 'message.tableCommon.status',
          type: 'select',
          defValue: '',
          options: [],
        },
        {
          key: ['createTimeStart', 'createTimeEnd'],
          name: 'message.tableCommon.creationTime',
          defValue: initWeek(),
          type: 'date_time',
        },
        {
          key: ['finishedTimeStart', 'finishedTimeEnd'],
          name: 'message.transfer.completionTime',
          type: 'date_time',
        },
      ],
      searchButtonList: [],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.merchantOrderNumber' },
          key: 'externalOrderId',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.txnSerialNumber' },
          key: 'id',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.originalTxnSerialNumber' },
          key: 'originTxnId',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.txnType' },
          key: 'shareType',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.shareTypeList, row.shareType),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.currency' },
          key: 'currency',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.index.amount' },
          key: 'amount',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.dividendDetailsNo' },
          key: 'referenceId',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.dividendTxnSerialNo' },
          key: 'shareId',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.dividendReceivingAccount' },
          key: 'accountNo',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.describes' },
          key: 'description',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.notifyUrl' },
          key: 'notifyUrl',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'status',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.statusList, row.status),
          itemStyle: (data) => {
            const text = getEnantiomericValue(this.statusList, data.status);
            if (!text) {
              return '';
            }
            if (data.status === 'S') { // 成功
              return ';min-width: 58px;height: 27px;text-align: center;background:rgba(0,221,40,0.15);border-radius:4px;font-weight: 800;line-height: 27px;';
            } else if (data.status === 'P') { // 处理中
              return 'min-width: 58px;height: 27px;text-align: center;background:rgba(255,178,9,0.15);border-radius:4px;font-weight: 800;line-height: 27px;';
            }
            return 'min-width: 58px;height: 27px;text-align: center;background:rgba(252,100,45,0.15);border-radius:4px;font-weight: 800;line-height: 27px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.creationTime' },
          key: 'createTime',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.transfer.completionTime' },
          key: 'finishedTime',
          type: 'text',
        },
      ],
      shareTypeList: [],
      statusList: [],
    };
  },
  mounted() {
    GlobalData.getDictList(['MERC_TXN_STATUS', 'TXN_TYPE_ACCOUNT']).then((res) => {
      res.MERC_TXN_STATUS.forEach((item) => {
        if (['P', 'S', 'F'].includes(item.value)) {
          this.statusList.push({
            text: item.description,
            label: item.description,
            value: item.value,
          });
        }
      });
      this.shareTypeList = initSelectedData(res.TXN_TYPE_ACCOUNT);
      if (this.$refs.search) {
        this.$refs.search.setSearchSelectOptions('status', this.statusList);
      }
      if (this.$refs.table) {
        this.$refs.table.firstVisitHttp();
      }
    }).catch(() => {
    });
  },
  methods: {
    ...DividendService,
    getInitParams() {
      return {
        ...getWeekParams('createTimeStart', 'createTimeEnd'),
      };
    },
  },
};
</script>
